<div class="item-grid-container py-lg-2 pt-lg-2 p-0">
  <div class="account-details-label">
    <mat-card class="account-details-card text-white">
      <ul class="list-inline d-inline-flex">
        <li class="list-inline-item align-self-center d-inline-block d-xl-none">
          <button mat-mini-fab aria-label="toggle show hide" color="primary" (click)="showCard = !showCard">
            <mat-icon *ngIf="!showCard">arrow_back_ios</mat-icon>
            <mat-icon *ngIf="showCard">arrow_forward_ios</mat-icon>
          </button>
        </li>
        <li class="list-inline-item">
          <ul class="list-unstyled" *ngIf="showCard">
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.userName </span>: {{ retailerdata?.retailerDetails?.dbaName }}
              </h4>
            </li>
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.accountNumber </span>:
                 {{retailerdata?.retailerAccounts?.retailerAccountNum}}
              </h4>
            </li>
            <li>
              <h4>
                <span translate class="translate"> pages.newRetailer.availableBalance </span>:
                {{ retailerdata?.retailerAccountSummary?.currentAmount | currency }}
              </h4>
            </li>
            <li></li>
          </ul>
        </li>
      </ul>
    </mat-card>
  </div>
</div>
<div class="transaction-content pt-2">
  <div class="transaction-duration search-holder">
    <ul class="list-inline grid-top-actions mb-3">
      <li class="list-inline-item">
        <p class="mb-2 mx-2">{{'pages.Creditlinereport.From' | translate }}</p>
      </li>
      <li class="list-inline-item">
        <div class="calendar-btn">
          <input matInput [matDatepicker]="dpFrom" disabled [min]="minFromDate" placeholder="MM/DD/YYYY" [max]="maxDate"
            [formControl]="fromCntrl" (dateChange)="changeFromDate($event)" />
          <mat-datepicker-toggle matSuffix [for]="dpFrom"></mat-datepicker-toggle>
          <mat-datepicker #dpFrom disabled="false"></mat-datepicker>
        </div>
      </li>
      <li class="list-inline-item">
        <p class="mb-2 mx-2">{{'pages.Creditlinereport.To' | translate }}</p>
      </li>
      <li class="list-inline-item">
        <div class="calendar-btn">
          <input matInput [matDatepicker]="dpTo" disabled [min]="minToDate" placeholder="MM/DD/YYYY"
            [formControl]="toCntrl" [max]="maxDate" (dateChange)="changeToDate($event)" />
          <mat-datepicker-toggle matSuffix [for]="dpTo"></mat-datepicker-toggle>
          <mat-datepicker #dpTo disabled="false"></mat-datepicker>
        </div>
      </li>
      <li class="list-inline-item ">
        <div class="search-holder">
          <input type="text" placeholder="{{ 'pages.newRetailer.search' | translate }}" matInput class="
              rounded-pill
              px-3
              py-2
              mb-0
              border-0
              bg-light
              w-100
              me-0
              input-search
              ms-3
            " (keyup)="quickSearch()" [(ngModel)]="searchValue" />
        </div>
      </li>
      <!-- <li class="list-inline-item">
                <h4 class="transaction-dates">{{transactionFromDate}} - {{transactionToDate}}</h4>
              </li> -->

      <li class="list-inline-item float-lg-end">
        <button mat-stroked-button color="primary" class="" (click)="exportData()">
          <span translate class="translate">pages.newRetailer.download</span>
          <i class="mi mi-save-alt"></i>
        </button>
      </li>

      <li class="list-inline-item float-lg-end">
        <button mat-stroked-button (click)="onClickYear()" color="primary">
          {{ 'pages.placeholders.Thisyear' | translate }}
        </button>
      </li>
      <li class="list-inline-item float-lg-end">
        <button mat-stroked-button (click)="onClickMonth()" color="primary">
          {{ 'pages.placeholders.Thismonth' | translate }}
        </button>
      </li>
    </ul>
  </div>
  <hr />
  <div class="stats-blks-holder mt-0 mt-sm-5 mt-xl-0">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <div class="sales-card card border-0 py-3 px-2 rounded bg-theme-light">
          <h5>
            {{ 'pages.newRetailer.salesSummary' | translate}} <br />
            <span class="values"> {{ this.transactionSummary | currency }}
            </span>
          </h5>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <div class="sales-card card border-0 py-3 px-2 rounded bg-theme-light">
          <h5>
            {{ 'pages.newRetailer.commissionSummary' | translate}} <br />
            <span class="values"> {{ this.commissionSummary | currency }}
            </span>
          </h5>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
        <div class="sales-card card border-0 py-3 px-2 rounded bg-theme-light">
          <h5> Promo Code Amount Summary
            <br />
            <span class="values"> {{ this.promocodeSummary | currency }}
            </span>
          </h5>
        </div>
      </div>
    </div>
  </div>
  <hr class="mb-0" />

  <div class="transactions-grid-container card p-3 mt-1 border-0">
    <ag-grid-angular style="width: 100%; height: 50vh" class="ag-theme-material" [rowHeight]="40" [enableFilter]="true"
      [enableSorting]="true" [enableColResize]="true" [rowSelection]="'single'" [rowData]="rowData"
      [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </div>
</div>